import React from "react";
import ReactDOM from "react-dom/client";

import "./static/fonts/Albert_Sans/AlbertSans-VariableFont_wght.ttf";
import "./static/fonts/Bitter/Bitter-VariableFont_wght.ttf";

import "./styles/styles.scss";

import reportWebVitals from "./reportWebVitals";
import { loadTheme } from "./utils/theme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
// Le theme (/theme.json) est charge AVANT d importer l application : des
// constantes de module (adresses initiales, ...) lisent getTheme() au moment
// ou leur fichier est evalue, donc apres ce chargement.
loadTheme()
  .then(() => import("./App"))
  .then(({ default: App }) => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
